import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    _paq?: Array<unknown[]>;
  }
}

export function trackMatomoEvent(category: string, action: string, name?: string, value?: number) {
  const _paq = window._paq;
  if (_paq) {
    _paq.push(["trackEvent", category, action, name, value]);
  }
}

export function useMatomoPageView() {
  const location = useLocation();

  useEffect(() => {
    const _paq = window._paq;
    if (_paq) {
      _paq.push(["setCustomUrl", window.location.href]);
      _paq.push(["setDocumentTitle", document.title]);
      _paq.push(["trackPageView"]);
    }
  }, [location.pathname]);
}
